export const PingenLetterStatusLabels = {
  validating: "Validating",
  ready_for_sending: "Ready for Sending",
  action_required: "Action Required",
  invalid: "Invalid",
  submitted_for_sending: "Submitted for Sending",
  awaiting_credits: "Awaiting Credits",
  print_preparation: "Print Preparation",
  cancelling: "Cancelling",
  cancelled: "Cancelled",
  printing: "Printing",
  unprintable: "Unprintable",
  sent: "Sent",
  undeliverable: "Undeliverable",
  resent: "Resent",
};
